/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    /*
    MoyaComponents.register('ext.accordion', [
        '/static/local/accordion/js/accordion.js',
    ], (el) => {
        Accordion.init();
    })
     */
    var moyaToggle = MoyaContainer.get('core.toggle');
    var sections = document.querySelectorAll('section.accordion');
    var accordionCounter = 0;
    Array.prototype.forEach.call(sections, function (el) {
        //el.dataset.moyaComponent = 'ext.accordion';
        var wrapElements = function (elements, wrapper) {
            if (elements && elements.length) {
                elements[0].parentNode.insertBefore(wrapper, elements[0]);
                elements.forEach(function (child) { return wrapper.appendChild(child); });
            }
        };
        //Wrap title in button
        var title = el.querySelector('*:first-child');
        var button = document.createElement('button');
        button.innerHTML = title.innerHTML;
        el.id = 'accordion-' + getAnchorIdFromTitle(button.innerText);
        title.innerHTML = '';
        title.parentNode.insertBefore(button, title);
        title.remove();
        //Wrap content
        var wrapper = document.createElement('div');
        wrapper.classList.add('wrap');
        wrapper.id = 'accordion-' + ++accordionCounter;
        wrapper.dataset.moyaComponent = "core.max-height";
        wrapElements(el.querySelectorAll(':scope >*:not(:first-child)'), wrapper);
        moyaToggle.create(button, wrapper, 'accordion' + accordionCounter, {
            'onOpen': function (toggle) {
                toggle.getOpenElement().parentElement.classList.add('open');
                updateHash(getAnchorIdFromTitle(button.innerText));
            },
            'onClose': function (toggle) {
                toggle.getOpenElement().parentElement.classList.remove('open');
                updateHash('');
            },
            'closeOnBodyClick': false,
        });
        /*button.addEventListener('click', () => {

        });*/
        function updateHash(hash) {
            if (history.pushState) {
                history.pushState(null, null, '#' + hash);
            }
            else {
                location.hash = '#';
            }
        }
        function getAnchorIdFromTitle(title) {
            var anchor = title.trim().toLowerCase(), special = {
                á: 'a',
                ð: 'd',
                é: 'e',
                í: 'i',
                ó: 'o',
                ú: 'u',
                ý: 'y',
                þ: 'th',
                æ: 'ae',
                ö: 'o'
            }, r;
            for (var i in special) {
                r = new RegExp(i, "g");
                anchor = anchor.replace(r, special[i]);
            }
            return anchor.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, '-');
        }
        // Fix max height on nested accordions
        wrapper.addEventListener('transitionend', function () {
            window.dispatchEvent(new Event('resize'));
        });
        el.classList.add('ready');
    });
    if (location.hash && sections.length) {
        document.addEventListener("DOMContentLoaded", function () {
            var _a;
            var section = document.querySelector(location.hash.replace('#', '#accordion-'));
            if (section) {
                var btn = section.querySelector('button[aria-haspopup]');
                if (btn) {
                    var offset_1 = parseInt((_a = document.querySelector('header').dataset.offset) !== null && _a !== void 0 ? _a : '0');
                    btn.click();
                    setTimeout(function () {
                        window.scrollTo({
                            top: section.getBoundingClientRect().top - offset_1,
                            behavior: "smooth"
                        });
                    }, 500);
                }
            }
        });
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
